var exports = {
  "k": "x43aef4ae--7072ad--container",
};

module.exports = exports;
